import React from 'react';
import { Tag } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { useTranslation } from 'react-i18next';
import {
  CheckCircleOutlined,
} from '@ant-design/icons';
import { useRecoilValue } from 'recoil';
import { businessAtom } from '../../../../atoms/Atoms';

function DeliveriesHeader() {
  const business = useRecoilValue(businessAtom);
  const { t } = useTranslation();

  return (
    <PageHeader
      className="px-0 text-lg"
      title={t('deliveries')}
      tags={
        <Tag
          color="#2db7f5"
          icon={<CheckCircleOutlined />}
        >
          {business ? business.name : t('all_stores')}
        </Tag>
      }
    />
  );
}

export default DeliveriesHeader;
